import React, { Component } from 'react';
import { connect } from 'react-redux';
import PrescreenSelectGroup from 'components/forms/vendor-request/prescreen-select-group';
import { FormSectionContainer as Container } from 'components/styled-components';

class PrescreenFormSection extends Component {
  questionIterator = () => {
    const modifiedQuestions = this.props.questions.result.map(c => {
      const modifiedAnswers = c.answers.map(a => {
        return {
          answer: a.answer,
          answerID: a.answerID,
          questionID: c.questionID,
        };
      });
      c.answers = modifiedAnswers;
      return c;
    });
    return modifiedQuestions.map((c, index) => (
      <PrescreenSelectGroup
        key={index}
        index={index}
        class={this.props.isFetching && 'bp3-skeleton'}
        questionID={c.questionID}
        label={c.question}
        placeholder={`Choose ${c.question}`}
        asyncOptions={c.answers}
        multi={c.answerLimit === 1 ? false : true}
        onChange={this.props.setFieldValue}
        onBlur={this.props.setFieldTouched}
        name="prescreen"
        labelKey="answer"
        valueKey="answerID"
        max={c.answerLimit}
        value={this.props.values.prescreen[index]}
        {...this.props}
      />
    ));
  };
  render() {
    if (this.props.isFetching) return <div>Loading...</div>;
    return <Container>{this.questionIterator()}</Container>;
  }
}

const mapStateToProps = state => ({
  questions: state.prescreen.questions,
});

PrescreenFormSection = connect(
  mapStateToProps,
  {}
)(PrescreenFormSection);

export default PrescreenFormSection;
